(function () {
  "use strict";

// [module] src/runtime/modules/cart/runtime.mjs
function scheduleCartAffirmSpacingPatch(rootNode) {
    if (window.__sternScheduleAffirmSpacingPatch && typeof window.__sternScheduleAffirmSpacingPatch === "function") {
        window.__sternScheduleAffirmSpacingPatch({
            rootNode: rootNode,
            timerKey: "cart"
        });
    }
}

function handleBundleRemoveClick(event) {
    if (!event.target || !event.target.closest) {
        return;
    }

    var button = event.target.closest(".remove-bundle-btn");
    if (!button) {
        return;
    }

    var parent = button.closest("tr");
    if (!parent) {
        return;
    }

    var input = parent.querySelector(".quantity");
    if (input) {
        input.value = 0;
    }
}

var activeCartUpdateController = null;

function handleCartSubmit(event) {
    var cartForm = event.target;
    if (!(cartForm instanceof window.HTMLFormElement) || cartForm.name !== "cart") {
        return;
    }

    var submitter = event.submitter && event.submitter.name ? event.submitter.name : "";
    if (submitter !== "update" && submitter !== "remove") {
        return;
    }

    event.preventDefault();

    if (activeCartUpdateController) {
        activeCartUpdateController.abort();
    }
    activeCartUpdateController = new AbortController();

    var quantityData = cartForm.querySelectorAll("input[name='updates[]'][data-keys]");
    var updates = {};

    quantityData.forEach((quantity) => {
        var currentQuantity = quantity.getAttribute("data-keys");
        if (!currentQuantity) {
            return;
        }

        var parsedQty = parseInt(quantity.value, 10);
        if (isNaN(parsedQty) || parsedQty < 0) {
            parsedQty = 0;
        }

        var currentQuantityData = currentQuantity.split(",");
        currentQuantityData.forEach((key) => {
            updates[key] = parsedQty;
        });
    });

    var submitButton = cartForm.querySelector("[name='update'], [name='remove']");
    if (submitButton) {
        submitButton.disabled = true;
    }

    fetch("/cart/update.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({ updates: updates }),
        signal: activeCartUpdateController.signal
    })
        .then((response) => {
            if (!response.ok) {
                throw new Error("Cart update failed");
            }
            return response.json();
        })
        .then(() => {
            activeCartUpdateController = null;
            if (window.themeModern && typeof window.themeModern.refreshCartSection === "function") {
                var cartSectionNode = cartForm.closest("[id^=\"shopify-section-\"]");
                var cartSectionId = cartSectionNode && cartSectionNode.id
                    ? cartSectionNode.id.replace("shopify-section-", "")
                    : undefined;
                return window.themeModern.refreshCartSection({
                    sectionId: cartSectionId,
                    hardReloadOnError: true
                });
            }
            window.location.reload();
            return null;
        })
        .catch((error) => {
            if (error && error.name === "AbortError") {
                return;
            }
            activeCartUpdateController = null;
            if (submitButton) {
                submitButton.disabled = false;
            }
            console.error("Error updating cart:", error);
            if (window.alertNotification && typeof window.alertNotification.error === "function") {
                window.alertNotification.error("There was a problem updating your cart. Please try again.");
            }
            window.location.reload();
        });
}

function handleCartSectionRendered(event) {
    var detail = event && event.detail ? event.detail : {};
    var sectionId = detail.sectionId || "";
    var sectionRoot = sectionId ? document.getElementById("shopify-section-" + sectionId) : document;
    scheduleCartAffirmSpacingPatch(sectionRoot || document);
}

function registerCartRuntime() {
    function initCartRuntime() {
        scheduleCartAffirmSpacingPatch(document);
        document.addEventListener("click", handleBundleRemoveClick);
        document.addEventListener("submit", handleCartSubmit);
        window.addEventListener("theme:cart:section:rendered", handleCartSectionRendered);
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initCartRuntime, { once: true });
        return;
    }

    initCartRuntime();
}

// [module] src/runtime/entries/scripts-cart.mjs

registerCartRuntime();

})();
